import api from "../../utils/api";

// NZSC-3250 — AI 프롬프트 관리 (CS 컨시어지 / AI 계약상담 / 리포트 질문 답변).
// api-admin src/ax 프롬프트 툴(NZSC-3225 확장판) 호출. 응답은 {code,data} 봉투 없이 raw
// ({success, ...}) 로 내려온다(ax 컨트롤러 컨벤션).
//   GET  /api/v1/ax/prompt?target=cs|alfred|reportQna     → {success, prompt, version}
//   POST /api/v1/ax/prompt/deploy {target, prompt}        → {success, steps[], buildId?, buildTypeId?}
//   GET  /api/v1/ax/cs/prompt/deploy-status?buildId=      → {success, state, status, finished}
//   POST /api/v1/ax/cs/prompt/chat {message, systemPrompt?, chatId?} → {success, chatId, response} (CS 전용)

export const state = {};
export const mutations = {};

export const actions = {
  async acPromptLoad(_, { target }) {
    try {
      const res = await api.get("/api/v1/ax/prompt", { params: { target } });
      return res.data;
    } catch (error) {
      return { success: false, error: error?.response?.data?.message || error?.message };
    }
  },
  async acPromptDeploy(_, { target, prompt }) {
    try {
      const res = await api.post("/api/v1/ax/prompt/deploy", { target, prompt });
      return res.data;
    } catch (error) {
      return { success: false, error: error?.response?.data?.message || error?.message, steps: [] };
    }
  },
  async acPromptDeployStatus(_, { buildId, buildTypeId }) {
    try {
      const res = await api.get("/api/v1/ax/cs/prompt/deploy-status", {
        params: { buildId, buildTypeId },
      });
      return res.data;
    } catch (error) {
      return { success: false, error: error?.message };
    }
  },
  // NZSC-3250: 리포트 질문답변 실전 테스트 — 편집중 프롬프트+실리포트 데이터로 즉석 생성(저장 없음). LLM이라 최대 90초.
  async acPromptQnaTest(_, { report_seq, question, system_prompt }) {
    try {
      const res = await api.post(
        "/api/v1/ax/prompt/qna-test",
        { report_seq, question, system_prompt },
        { timeout: 90000 },
      );
      return res.data;
    } catch (error) {
      return { success: false, error: error?.response?.data?.message || error?.message };
    }
  },
  async acPromptChatTest(_, { message, systemPrompt, chatId }) {
    try {
      const res = await api.post("/api/v1/ax/cs/prompt/chat", { message, systemPrompt, chatId });
      return res.data;
    } catch (error) {
      return { success: false, error: error?.message };
    }
  },
};

export const getters = {};

export default { namespaced: true, state, actions, mutations, getters };
